// Asistan yanıtını dosya olarak indirme — sohbet penceresindeki "Excel" / "PDF" düğmeleri.
// Asistan dosya üretmez; kullanıcı ekranda GÖRDÜĞÜ yanıtı indirir (içerik değişmez, yalnız biçim).
import api from '../../services/api'
import { loadXLSX } from '../../utils/exportUtils'
import { extractTables } from '../../utils/miniMarkdown'

const stamp = () => {
  const d = new Date()
  const p = (n) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}_${p(d.getHours())}${p(d.getMinutes())}`
}

// "1.234.567" / "12,5" / "-3" → sayı; para birimli ya da metinli hücre olduğu gibi kalır.
const asCell = (v) => {
  const s = String(v ?? '').trim()
  if (/^-?\d{1,3}(\.\d{3})*(,\d+)?$/.test(s) || /^-?\d+(,\d+)?$/.test(s)) {
    const n = Number(s.replace(/\./g, '').replace(',', '.'))
    if (Number.isFinite(n)) return n
  }
  return s
}

export const answerHasTable = (text) => extractTables(text).length > 0

/** Yanıttaki her tablo ayrı sayfa; tablo yoksa yanıt metni tek sütun. */
export async function exportAnswerExcel(text, { title } = {}) {
  const XLSX = await loadXLSX()
  const wb = XLSX.utils.book_new()
  const tables = extractTables(text)
  if (tables.length) {
    tables.forEach((t, i) => {
      const aoa = [t.header, ...t.rows.map((r) => t.header.map((_, ci) => asCell(r[ci])))]
      const ws = XLSX.utils.aoa_to_sheet(aoa)
      ws['!cols'] = t.header.map((h, ci) => ({
        wch: Math.min(60, Math.max(10, String(h).length + 2,
          ...t.rows.map((r) => String(r[ci] ?? '').length + 2))),
      }))
      XLSX.utils.book_append_sheet(wb, ws, tables.length > 1 ? `Tablo ${i + 1}` : 'Tablo')
    })
  } else {
    const ws = XLSX.utils.aoa_to_sheet([[title || 'Asistan yanıtı'], ...String(text || '').split('\n').map((l) => [l])])
    ws['!cols'] = [{ wch: 120 }]
    XLSX.utils.book_append_sheet(wb, ws, 'Yanıt')
  }
  XLSX.writeFile(wb, `vertex-asistan_${stamp()}.xlsx`)
}

function printFallback(html, title) {
  // PDF motoru yoksa tarayıcının yazdır penceresi ("PDF olarak kaydet").
  const f = document.createElement('iframe')
  f.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0'
  document.body.appendChild(f)
  const doc = f.contentDocument
  doc.open()
  doc.write(`<!doctype html><html><head><meta charset="utf-8"><title>${title}</title>
    <style>body{font-family:Arial,sans-serif;font-size:12px;color:#1f2937;margin:24px}
    table{border-collapse:collapse;width:100%;margin:8px 0}th,td{border:1px solid #d1d5db;padding:3px 6px;text-align:left}
    th{background:#f3f4f6}h1{font-size:16px;border-bottom:2px solid #6C5CE7;padding-bottom:4px}</style>
    </head><body><h1>${title}</h1>${html}</body></html>`)
  doc.close()
  setTimeout(() => { f.contentWindow.focus(); f.contentWindow.print(); setTimeout(() => f.remove(), 2000) }, 250)
}

/** Ekranda çizilmiş yanıt HTML'i → sunucuda A4 PDF; motor yoksa yazdır penceresi. */
export async function exportAnswerPdf(html, { title, question, company, brand, filename } = {}) {
  const t = title || 'Asistan yanıtı'
  try {
    const res = await api.post('/ai/export-pdf', { html, title: t, question, company, brand },
      { responseType: 'blob', timeout: 60000 })
    const url = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }))
    const a = document.createElement('a')
    a.href = url
    a.download = filename || `vertex-asistan_${stamp()}.pdf`
    document.body.appendChild(a)
    a.click()
    a.remove()
    setTimeout(() => URL.revokeObjectURL(url), 5000)
    return 'pdf'
  } catch (e) {
    if (e?.response?.status === 503) {
      printFallback(html, t)
      return 'print'
    }
    throw e
  }
}
